import { render, staticRenderFns } from "./basicsettings.vue?vue&type=template&id=78d75471&scoped=true&"
import script from "./basicsettings.vue?vue&type=script&lang=js&"
export * from "./basicsettings.vue?vue&type=script&lang=js&"
import style0 from "./basicsettings.vue?vue&type=style&index=0&id=78d75471&scoped=true&lang=css&"
import style1 from "./basicsettings.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d75471",
  null
  
)

export default component.exports